/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { memo } from 'react';

import { ExpandMore } from '@material-ui/icons';

import { object } from 'prop-types';
import { generate } from 'shortid';

import HeaderDrawerSubCategory from './HeaderDrawerSubCategory';
import { ExpansionPanelStyled, ExpansionPanelSummaryStyled, ExpansionPanelDetailsStyled, Link } from './styles';

const HeaderDrawerCategory = ({ category }) => (
  <ExpansionPanelStyled elevation={0}>
    <ExpansionPanelSummaryStyled expandIcon={category.children <= 0 ? null : <ExpandMore />} category="true">
      <Link
        onClick={() => {
          if (category.children <= 0) {
            location.href = category.link;
          }
        }}
        title={category.title}
        aria-label={category.title}
      >
        {category.title}
      </Link>
    </ExpansionPanelSummaryStyled>
    <ExpansionPanelDetailsStyled>
      <Link
        onClick={() => {
          location.href = category.link;
        }}
        title={category.title}
        aria-label={category.title}
      >
        Ver tudo em {category.title}
      </Link>
      {category.children.map((sub) => (
        <HeaderDrawerSubCategory subCategory={sub} key={generate()} />
      ))}
    </ExpansionPanelDetailsStyled>
  </ExpansionPanelStyled>
);

HeaderDrawerCategory.propTypes = {
  category: object,
};

export default memo(HeaderDrawerCategory);
